import { ProductType } from "../../interfaces/DTO/mislaka_xml_models";
import { FundDataBasic } from "../../interfaces/DTO/FundDataBasic";

export enum ChartType {
  YieldBubbles = "yield_bubbles",
  FundYieldsChart = "fund_yields_chart",
}

export interface FundPopulation {
  id: string;
  name: string;
  topCount: number;
  sortField: string;
  fundIds: number[];
}

export interface DisplayPreferences {
  filterPopulation: boolean; // true = הצג רק אחרי פילטר, false = הצג הכל
  colorBy: 'default' | 'subspecialization' | 'managing_corporation' | 'stock_exposure' | 'foreign_exposure' | 'currency_exposure' | 'fund_classification' | 'percentile_6m_yield';
  pinnedItems: Record<string, string[]>; // key = filter name, value = array of pinned item values
}

export interface GemelDataFilteredView {
  productType: ProductType;
  buckets: string[];
  charts: ChartType[];
  fundPopulations: FundPopulation[];
  yAxisField?: keyof FundDataBasic;
  handlers: string[];
  subSpecializations: string[];
  stockExposureRanges: string[];
  foreignExposureRanges: string[];
  currencyExposureRanges: string[];
  displayPreferences: DisplayPreferences;
  forGeneralPublic?: boolean; // true = לציבור הרחב בלבד (target_population ריק), false/undefined = הכל
  includeIRA?: boolean; // true = כולל IRA, false/undefined = ללא IRA
}
